import { useCallback, useState } from "react";
import { useStore } from "react-redux";
import { Button, Collapse } from "react-bootstrap";

import Panel from "../panel/panel";
import { PartialItemList, Iframe } from "../partial";
import { ArrowDownIcon, ArrowUpIcon } from "../utils/components/icons";
import HinweiseDisplay from "../popups/HinweiseDisplay";

const Overview = (props) => {
  const { configStorage, hinweiseStorage } = useStore().getState();
  const [open, setOpen] = useState(false);  

  const onClick = useCallback(() => setOpen(!open), [open]);

  return (
    <div>
      { hinweiseStorage.hasUnreadHinweise() ? <HinweiseDisplay/> : null }
      <h2 className="aria-visible">Übersicht der vorhandenen Produkte</h2>
      {configStorage.isMaShop() && configStorage.getAppPath("info") && !configStorage.isVerseNeo()
        ? <div className="bg-white mb-one">
          <Button
            variant=""
            onClick={onClick}
            aria-controls="hinweis-content"
            aria-expanded={open}
            className="w-100 text-start"
          >
            {open
              ? <ArrowUpIcon />
              : <ArrowDownIcon />
            }
            Wichtige Hinweise
          </Button>
          <Collapse id="hinweis-content" in={open} mountOnEnter={true} unmountOnExit={true}>
            <div className="border-top pt-one pb-one">
              <Iframe className="w-100 h-50v" title="wichtige Hinweise" src={configStorage.getAppPath("info")} query=".main-block"/>
            </div>
          </Collapse>
        </div>
        : null
      }
      <section aria-label="Auswahloptionen">        
        <Panel />
      </section>
      <section aria-label="Ergebnisliste">
        <PartialItemList />
      </section>
      <div className="d-md-none buffer-area"></div>
    </div>
  );
};
export default Overview;
